import { Menu } from '@shared/components/Menu';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { LookupOverflowMenuContent } from './LookupOverflowMenuContent';
import { EntityAndField } from './types';
import styles from './RelatedLookupFieldOverflowMenu.module.css';

interface RelatedLookupFieldOverflowMenuProps {
  lookupFields: EntityAndField[];
  lookupComponent: API.AnyComponent;
  workflowTemplateId: string;
  extraCount: number;
  title?: string;
}

export function RelatedLookupFieldOverflowMenu({
  lookupFields,
  lookupComponent,
  workflowTemplateId,
  extraCount,
  title,
}: RelatedLookupFieldOverflowMenuProps) {
  return (
    <Menu>
      <Menu.Button
        variant="ghost"
        size="medium"
        label={i18n('common.showMoreWithCount', { count: extraCount })}
      />
      <Menu.Content className={styles.lookupOverflowMenu}>
        <LookupOverflowMenuContent
          lookupFields={lookupFields}
          lookupComponent={lookupComponent}
          workflowTemplateId={workflowTemplateId}
          title={title}
        />
      </Menu.Content>
    </Menu>
  );
}
